var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.organization.logo_url)?_c('img',{class:[!_vm.removeBaseClasses ? _vm.baseClasses : '', _vm.dynamicClasses, _vm.additionalClasses],attrs:{"src":_vm.organization.logo_url}}):_c('div',{class:[!_vm.removeBaseClasses ? _vm.baseClasses : '', _vm.dynamicClasses, _vm.additionalClasses]},[_vm._v("\n    "+_vm._s(_vm.organization.acronym)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }